import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getUSAPkgLookups } from '../usaPkgLookupService'

export function useUSAPkgLookups(enabled = true) {
  return useQuery({
    queryKey: [QUERY_KEYS.PKG_LOOKUPS],
    queryFn: getUSAPkgLookups,
    enabled,
  })
}
